import * as React from "react"
import { As, PropsOf, ComponentWithAs, RightJoinProps } from "./types"

export function forwardRef<Props extends object, Component extends As>(
  component: React.ForwardRefRenderFunction<
    any,
    RightJoinProps<PropsOf<Component>, Props> & {
      as?: As
    }
  >,
) {
  return (React.forwardRef(component as any) as unknown) as ComponentWithAs<
    Component,
    Props
  >
}
